import React from "react";
// @ts-ignore
import ReactDateRangePicker from "@wojtekmaj/react-daterange-picker";
import { DateRange } from "@material-ui/icons";
import { useStyles, GlobalCss } from "./styles";
import { DateRangePickerProps } from "./types";

const DateRangePicker = ({
  value,
  disabled,
  onChange,
  className
}: DateRangePickerProps) => {
  const classes = useStyles();

  return (
    <>
      <GlobalCss />
      <ReactDateRangePicker
        disabled={disabled}
        onChange={onChange}
        value={value}
        format={"yyyy-MM-dd"}
        required={true}
        calendarIcon={<DateRange />}
        className={
          className ??
          classes.dateRangePicker +
            " MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedEnd"
        }
        calendarClassName={classes.calendar}
        clearIcon={null}
      />
    </>
  );
};

export default DateRangePicker;
